import {
  initialState,
  Actions,
  State,
  EDIT_PERIODIC_CHECK_STATE,
  EDIT_PERIODIC_CHECK_STATE_SUCCESS,
  EDIT_PERIODIC_CHECK_STATE_ERROR,
  RESET_EDIT_PERIODIC_CHECK_STATE,
} from '../../types/periodic-check/edit-state'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_PERIODIC_CHECK_STATE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_PERIODIC_CHECK_STATE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_PERIODIC_CHECK_STATE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_PERIODIC_CHECK_STATE:
      return initialState
    default:
      return state
  }
}

export default reducers
